export default {
  props: {
    typesWithAssets: Array,
  },
  computed: {
    currentAsset() {
      const { assetId } = this.$route.params;
      return this.currentAssetType
        && this.currentAssetType.assets
          .find(({ id }) => assetId.toUpperCase() === id.toUpperCase());
    },
    currentAssetType() {
      const { assetId } = this.$route.params;
      return this.typesWithAssets
        .find(({ assets }) => assets
          .some(({ id }) => assetId.toUpperCase() === id.toUpperCase()));
    },
  },
};
